export const en = {
  EW_IMAGE: {
    HEADER: 'Image Library',
    SELECT_IMAGE: 'Select Image',
    RECOMMENDED_SIZE: 'Recommended image size',

    DRAG_DROP_MESSAGE: 'Select or drag a file to this area to upload',
    FILE_SIZE: 'File size limit is 10MB per file',
    MY_IMAGE: 'My Image',
    UNSPLASH: 'Unsplash',
    DONE: 'Done',
    CANCEL: 'Cancel',
    EMPTY_IMAGES_SCREEN_MESSAGE:"No images available yet",
    EMPTY_IMAGES_SCREEN_SUB_MESSAGE:"Please add images in library to continue..",
    NO_MATCH:"Nothing matches with your search",
    NO_MATCH_MESSAGES:"Try something new."
  },
};
